import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'noimage'
})
export class SinfotoPipe implements PipeTransform {

  transform(value: string): string {
    let noimage = 'assets/images/noimage.png';
    if ( !value ) {
      return noimage;
    }
    return ( value.length > 0 ) ? value : noimage;
  }

}



// WEBPACK FOOTER //
// /Users/diego/Documents/SirisWebSite/WebSite/src/app/pipes/noimage.pipe.ts